module.exports = __webpack_public_path__ + "components/flag/static/square/th-dc9622da5cf15bba8919243bb8437bfa.svg";